<template>
  <section class="carAppoint">
    <div class="carAppoint1">
      <viewTitle title="应用设置 / 车辆预约" :showReturn="false" />
      <div
        class="qywxApp"
        v-for="(element, elementIndex) in appListData"
        :key="elementIndex"
      >
        <p :class="elementIndex !== 0 ? 'pTitle2' : 'pTitle'">
          {{ element.name }} ({{ installAppAccout(element.app_list) }}/{{
            element.app_list.length
          }})
        </p>
        <div class="appList">
          <div
            v-for="(item, index) in element.app_list"
            :key="index"
            :i="item"
            class="appItem"
            @click="showAppDetail(item)"
          >
            <div class="eltag">
              <el-tag v-if="item.info_state == '1'" size="medium" effect="dark"
                >已启用</el-tag
              >
              <el-tag
                v-if="item.info_state == '2'"
                size="medium"
                type="info"
                effect="dark"
                >未安装</el-tag
              >
              <el-tag
                v-if="item.info_state == '3'"
                type="danger"
                size="medium"
                effect="dark"
                >已禁用</el-tag
              >
            </div>
            <div>
              <el-image class="logoCls" :src="item.logo_url"></el-image>
              <p class="appName">{{ item.app_name }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="wxApp">
        <p class="pTitle">微信公众号应用 (2/2)</p>
        <div class="appList">
          <div
            v-for="(item, index) in wxAppList"
            :key="index"
            :i="item"
            class="appItem"
          >
            <div class="eltag">
              <el-tag size="medium" effect="dark">中等标签</el-tag>
            </div>
            <div>
              <el-image :src="src"></el-image>
              <p class="appName">应用名称</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :show-close="false"
      width="640px"
    >
      <div>
        <el-row type="flex" align="middle" :gutter="dialogCss.gutter">
          <el-col :span="dialogCss.lv1">
            <span class="">应用状态：</span>
          </el-col>
          <el-col :span="dialogCss.lv2">
            <span v-if="showDetial.info_state == '1'">已启用</span>
            <span v-if="showDetial.info_state == '2'">未安装</span>
            <span v-if="showDetial.info_state == '3'">已禁用</span>
          </el-col>
          <el-col :span="dialogCss.lv3"> </el-col>
        </el-row>
        <el-row
          v-if="showDetial.type == 'WXWORK-SELF'"
          type="flex"
          align="middle"
          :gutter="dialogCss.gutter"
        >
          <el-col :span="dialogCss.lv1">
            <span class="label">应用名称：</span>
          </el-col>
          <el-col :span="dialogCss.lv2">
            <el-input v-model="showDetial.app_name"></el-input>
          </el-col>
          <el-col :span="dialogCss.lv3"> </el-col>
        </el-row>
        <el-row
          v-if="showDetial.type == 'WXWORK-SELF'"
          type="flex"
          align="middle"
          :gutter="dialogCss.gutter"
        >
          <el-col :span="dialogCss.lv1">
            <span class="label">应用Logo：</span>
          </el-col>
          <el-col :span="dialogCss.lv2" class="appIcon">
            <el-image
              v-if="iconSrc.length > 0"
              class="iconImg"
              :src="iconSrc"
              fit="cover"
            ></el-image>
            <el-upload
              class="upload-demo"
              ref="upload"
              :http-request="uploadFile"
              action=""
              :auto-upload="true"
              :show-file-list="false"
              :multiple="true"
              :file-list="fileList"
            >
              <el-button type="text">修改</el-button>
            </el-upload>
          </el-col>
          <el-col :span="dialogCss.lv3"> </el-col>
        </el-row>
        <el-row
          v-if="showDetial.type == 'WXWORK-SELF'"
          type="flex"
          align="middle"
          :gutter="dialogCss.gutter"
        >
          <el-col :span="dialogCss.lv1">
            <span class="label">应用Id：</span>
          </el-col>
          <el-col :span="dialogCss.lv2">
            <el-input v-model="showDetial.wx_app_id"></el-input>
          </el-col>
          <el-col :span="dialogCss.lv3"> </el-col>
        </el-row>
        <el-row
          v-if="showDetial.type == 'WXMP'"
          type="flex"
          align="middle"
          :gutter="dialogCss.gutter"
        >
          <el-col :span="dialogCss.lv1">
            <span class="label">开发者ID（AppID）：</span>
          </el-col>
          <el-col :span="dialogCss.lv2">
            <el-input v-model="showDetial.wx_app_id"></el-input>
          </el-col>
          <el-col :span="dialogCss.lv3"> </el-col>
        </el-row>
        <el-row
          v-if="showDetial.type == 'WXWORK-SELF'"
          type="flex"
          align="middle"
          :gutter="dialogCss.gutter"
        >
          <el-col :span="dialogCss.lv1">
            <span class="label">应用Secret：</span>
          </el-col>
          <el-col :span="dialogCss.lv2">
            <el-input v-model="showDetial.secret"></el-input>
          </el-col>
          <el-col :span="dialogCss.lv3"> </el-col>
        </el-row>
        <el-row
          v-if="showDetial.type == 'WXMP'"
          type="flex"
          align="middle"
          :gutter="dialogCss.gutter"
        >
          <el-col :span="dialogCss.lv1">
            <span class="label">开发者密码（AppSecret）：</span>
          </el-col>
          <el-col :span="dialogCss.lv2">
            <el-input v-model="showDetial.secret"></el-input>
          </el-col>
          <el-col :span="dialogCss.lv3"> </el-col>
        </el-row>
        <el-row type="flex" align="middle" :gutter="dialogCss.gutter">
          <el-col :span="dialogCss.lv1">
            <span class="label">Token：</span>
          </el-col>
          <el-col :span="dialogCss.lv2">
            <el-input v-model="showDetial.token"> </el-input>
          </el-col>
          <el-col :span="dialogCss.lv3">
            <el-button type="text" @click="newToken">随机生成</el-button>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" :gutter="dialogCss.gutter">
          <el-col :span="dialogCss.lv1">
            <span class="label">EncodingAESKey：</span>
          </el-col>
          <el-col :span="dialogCss.lv2">
            <el-input v-model="showDetial.aes_key"></el-input>
          </el-col>
          <el-col :span="dialogCss.lv3">
            <el-button type="text" @click="newAesKey">随机生成</el-button>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" :gutter="dialogCss.gutter">
          <el-col :span="dialogCss.lv1">
            <span class="">回调url：</span>
          </el-col>
          <el-col :span="dialogCss.lv2">
            <el-input v-model="showDetial.callback_url"></el-input>
          </el-col>
          <el-col :span="dialogCss.lv3">
            <el-button
              type="text"
              v-clipboard:copy="showDetial.callback_url"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              >复制链接</el-button
            >
          </el-col>
        </el-row>
        <el-row
          v-if="showDetial.type == 'WXMP'"
          type="flex"
          align="middle"
          :gutter="dialogCss.gutter"
        >
          <el-col :span="dialogCss.lv1">
            <span class="">菜单url：</span>
          </el-col>
          <el-col :span="dialogCss.lv2">
            <el-input v-model="showDetial.menu_config"></el-input>
          </el-col>
          <el-col :span="dialogCss.lv3">
            <el-button
              type="text"
              v-clipboard:copy="showDetial.home_url"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              >复制链接</el-button
            >
          </el-col>
        </el-row>
        <el-row
          v-if="showDetial.type == 'WXMP'"
          type="flex"
          align="middle"
          :gutter="dialogCss.gutter"
        >
          <el-col :span="dialogCss.lv1">
            <span class="">二维码：</span>
          </el-col>
          <el-col :span="dialogCss.lv2">
            <!-- <div id="qrcode"></div> -->
            <exportButton
              v-if="downloadqrcode"
              type="text"
              text="下载二维码"
              :downLoadName="showDetial.download_name"
              :fileUrl="showDetial.download_url"
            ></exportButton>
            <!-- <el-button type="text">下载二维码</el-button> -->
          </el-col>
          <el-col :span="dialogCss.lv3"> </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="showDetial.type == 'WXWORK-SELF'"
          type="primary"
          @click="installApp"
          >安装应用</el-button
        >
        <el-button
          v-if="showDetial.type == 'WXWORK-SELF'"
          type="primary"
          @click="saveSetting"
          >保存配置</el-button
        >

        <el-button
          v-if="showDetial.type == 'WXMP'"
          type="primary"
          @click="saveWxSetting"
          >保存配置</el-button
        >
        <el-button
          v-if="showDetial.info_state == 1"
          type="primary"
          @click="offOnApp"
          >禁用</el-button
        >
        <el-button
          v-if="showDetial.info_state == 3"
          type="primary"
          @click="offOnApp"
          >启用</el-button
        >
        <el-button @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import viewTitle from "@/components/viewTitle";
import exportButton from "@/components/export";
import board_icon from "./board_icon.png";
import Chance from "chance";
// import QRCode from "qrcodejs2";
export default {
  props: {},
  data() {
    return {
      src: board_icon,
      qywxAppList: [{}, {}, {}, {}, {}, {}, {}],
      wxAppList: [{}, {}, {}, {}, {}, {}],
      showDetial: {
        url: "http:www.werwe"
      },
      dialogVisible: false,
      rules: [],
      dialogCss: {
        gutter: 20,
        lv1: 8,
        lv2: 12,
        lv3: 4
      },
      fileList: [],
      iconSrc: "",
      iconPath: "",
      listTop: [],
      appListData: [],
      dialogTitle: "",
      topCategoryId: "",
      downloadqrcode: false
    };
  },
  watch: {},
  components: {
    viewTitle,
    exportButton
  },
  beforeRouteUpdate(_to, _from, next) {
    this.topCategoryId = _to.params.id;
    this.getAppList();
    next();
  },
  computed: {
    installAppAccout() {
      return list => {
        let accout = 0;
        list.forEach(element => {
          if (element.info_state == 1) {
            accout++;
          }
        });
        return accout;
      };
    }
  },
  async mounted() {},
  methods: {
    showAppDetail(detail) {
      this.downloadqrcode = false;
      this.showDetial = JSON.parse(JSON.stringify(detail));
      this.iconSrc = this.showDetial.logo_url;
      this.iconPath = this.showDetial.logo_url;
      this.dialogTitle = `[ ${this.showDetial.app_name} ]应用设置`;
      this.dialogVisible = true;
      if (this.showDetial.type == "WXMP") {
        // setTimeout(() => {
        //   document.getElementById("qrcode").innerHTML = "";
        //   new QRCode("qrcode", {
        //     text: this.showDetial.home_url,
        //     width: 280,
        //     height: 280
        //   });
        // }, 100);
        this.$common
          .http({
            method: "get",
            url: `/api/app/download_menu_qrcode?app_id=${this.showDetial.id}`,
            noLoading: true
          })
          .then(res => {
            this.showDetial.download_url = res.data.data.download_url;
            this.showDetial.download_name = res.data.data.file_name;
            this.downloadqrcode = true;
          });
      }
    },
    onFileSuccess() {},
    uploadFile(req) {
      console.log(req);
      this.iconSrc = window.URL.createObjectURL(req.file);
      const data = new FormData();
      data.append("file", req.file);
      this.$common
        .http({
          url: "/api/media/upload",
          file: data
        })
        .then(res => {
          console.warn(res);
          this.iconPath = res.data.data.real_path;
        });
    },
    onCopy(e) {
      this.$common.pcToastSuccess("复制成功");
      console.log(e);
    },
    onError(e) {
      this.$common.pcToastFail("复制失败，请重新复制");
      console.log(e);
    },
    getAppList() {
      this.$common
        .http({
          url: "/api/app/list_by_category",
          data: { id: this.topCategoryId }
        })
        .then(res => {
          console.log(res);
          this.appListData = res.data.data;
        });
    },
    newAesKey() {
      let chance = new Chance();
      this.showDetial.aes_key = chance.string({
        pool: "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        length: 43
      });
    },
    newToken() {
      let chance = new Chance();
      this.showDetial.token = chance.string({
        pool: "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        length: 32
      });
    },
    offOnApp() {
      let info_state = Number(this.showDetial.info_state);
      if (info_state == 1) {
        info_state = 3;
      } else if (info_state == 3) {
        info_state = 1;
        // eslint-disable-next-line no-empty
      } else {
      }
      this.$common
        .http({
          url: "/api/app/change_state",
          data: { app_id: this.showDetial.id, state: info_state }
        })
        .then(() => {
          this.dialogVisible = false;
          this.getAppList();
        });
    },
    saveSetting() {
      if (!this.qyWxCheck()) {
        return;
      }
      this.$common
        .http({
          url: "/api/app/update_wxwork_app_config",
          data: {
            app_id: this.showDetial.id,
            app_name: this.showDetial.app_name,
            wx_app_id: this.showDetial.wx_app_id,
            token: this.showDetial.token,
            secret: this.showDetial.secret,
            aes_key: this.showDetial.aes_key,
            logo_url: this.iconPath
          }
        })
        .then(() => {
          this.$common.pcToastSuccess("保存配置成功");
          this.getAppList();
        });
    },
    saveWxSetting() {
      if (this.showDetial.wx_app_id.length == 0) {
        this.$common.pcToastFail(`开发者ID（AppID）不能为空`);
        return;
      }
      if (this.showDetial.secret.length == 0) {
        this.$common.pcToastFail(`开发者密码（AppSecret）不能为空`);
        return;
      }
      if (this.showDetial.token.length == 0) {
        this.$common.pcToastFail(`Token不能为空`);
        return;
      }
      if (this.showDetial.aes_key.length == 0) {
        this.$common.pcToastFail(`EncodingAESKey不能为空`);
        return;
      }
      this.$common
        .http({
          url: "/api/app/update_wxmp_app_config",
          data: {
            app_id: this.showDetial.app_id,
            wx_app_id: this.showDetial.wx_app_id,
            token: this.showDetial.token,
            secret: this.showDetial.secret,
            aes_key: this.showDetial.aes_key
          }
        })
        .then(() => {
          this.dialogVisible = false;
          this.getAppList();
        });
    },
    installApp() {
      if (!this.qyWxCheck()) {
        return;
      }
      this.$common
        .http({
          url: "/api/app/install_wxwork_app",
          data: {
            app_id: this.showDetial.id
          }
        })
        .then(() => {
          this.$common.pcToastSuccess("安装应用成功");
          this.dialogVisible = false;
          this.getAppList();
        });
    },
    qyWxCheck() {
      if (this.showDetial.app_name.length == 0) {
        this.$common.pcToastFail(`应用名称不能为空`);
        return false;
      }
      if (this.iconPath.length == 0) {
        this.$common.pcToastFail(`请上传应用Logo`);
        return false;
      }
      if (this.showDetial.wx_app_id.length == 0) {
        this.$common.pcToastFail(`应用Id不能为空`);
        return false;
      }
      if (this.showDetial.secret.length == 0) {
        this.$common.pcToastFail(`应用Secret不能为空`);
        return false;
      }
      if (this.showDetial.token.length == 0) {
        this.$common.pcToastFail(`Token不能为空`);
        return false;
      }
      if (this.showDetial.aes_key.length == 0) {
        this.$common.pcToastFail(`EncodingAESKey不能为空`);
        return false;
      }
      return true;
    }
  },
  async created() {
    this.topCategoryId = this.$route.params.id;
    this.getAppList();
  }
};
</script>
<style lang="less" scoped>
.carAppoint {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  .carAppoint1 {
    padding: 16px;
    .wxApp {
      display: none;
    }
    .qywxApp,
    .wxApp {
      .pTitle {
        margin: 0;
        margin: 8px 0px 30px;
        font-size: 18px;
      }
      .pTitle2 {
        margin: 0;
        margin: 40px 0px 30px;
        font-size: 18px;
      }
      .appList {
        display: flex;
        flex-wrap: wrap;
        .logoCls {
          width: 102px;
          height: 102px;
          border: 24px solid #fff;
          box-shadow: -3px -4px 8px 0 rgba(0, 0, 0, 0.06),
            3px 4px 8px 0 rgba(0, 0, 0, 0.08);
          border-radius: 10px;
        }
      }
      .appItem {
        // padding: 10px;
        position: relative;
        margin-right: 40px;
        .eltag {
          position: absolute;
          z-index: 1;
          left: 24px;
          top: -12px;
          .el-tag--medium {
            height: 28px;
            line-height: 26px;
            font-size: 16px;
            color: #ffffff;
          }
          .el-tag--dark {
            background-color: #3389f1;
            border-color: #3389f1;
            color: #fff;
          }
        }
        .appName {
          text-align: center;
          margin: 0;
          font-size: 16px;
          margin-top: 14px;
        }
      }
    }
  }
  .el-dialog__body {
    .label:before {
      content: "*";
      color: #f56c6c;
    }
    margin-right: 4px;
    padding: 10px 50px 10px 20px;
    .el-row {
      margin-bottom: 10px;
      .el-col-8 {
        text-align: right;
      }
    }
    .appIcon {
      display: flex;
      align-items: center;
      .iconImg {
        width: 50px;
        height: 50px;
        margin-right: 10px;
      }
    }
  }
}
</style>
<style lang="less">
.carAppoint {
  .logoCls {
    .el-image__inner {
      border-radius: 10px;
      object-fit: cover;
    }
  }
}
</style>
